<template>
  <div id="home" class="content-center">
      <h1 class="hidden">Home</h1>
      <malden-student-form></malden-student-form>
  </div>
</template>

<script>
import maldenStudentForm from "@/components/Malden-Student-Form";

export default {
  name: "home",
  components: {
    maldenStudentForm
  }
};
</script>
